module.exports = __webpack_public_path__ + "static/media/map-marker.3b68a630.svg";